import {
  BasicProps as BaseHeaderProps,
  Header as BaseHeader,
} from 'antd/lib/layout/layout'

export interface HeaderProps extends BaseHeaderProps {}

export const Header = (props: HeaderProps): JSX.Element => (
  <>
    <BaseHeader {...props} />
  </>
)
